import type { ArticlesListQuery } from "~/api/prismic/graphql"
import { linkResolver } from "~/api/prismic/linkResolver"
import type { PreviewProps } from "~/components/PublishedItemPreview"
import { getListQueryNodes } from "~/utils/graphql"
import {
  getImageDetails,
  getRichTextBlocks,
} from "~/utils/prismic/assertJsonTypes"
import * as RichText from "~/utils/prismic/richText"
import { withoutFalsyValues } from "~/utils/withoutFalsyValues"

export const mapPagesToPreviewPropsList = (
  pages: ArticlesListQuery[],
): PreviewProps[] => {
  const previews = pages
    .flatMap((page) => getListQueryNodes(page._allDocuments))
    .map<PreviewProps | null>((item) => {
      if (!item._meta.uid) {
        return null
      }

      const href = linkResolver({
        uid: item._meta.uid,
        type: item.__typename,
      })

      switch (item.__typename) {
        case "Article":
          return {
            href,
            title: RichText.asText(getRichTextBlocks(item.rtTitle)),
            description:
              item.description ||
              RichText.asText(getRichTextBlocks(item.subtitle)),
            image: getImageDetails(item.image),
            date: item._meta.firstPublicationDate,
          }

        case "Podcast_episode":
          return {
            href,
            title: item.title || "",
            description: item.description || "",
            image: getImageDetails(item.image),
            date: item._meta.firstPublicationDate,
            badge: {
              text: "Podcast",
              classes: "bg-violet-500 text-white",
            },
          }

        case "Newsletter":
          return {
            href,
            title: RichText.asText(getRichTextBlocks(item.rtTitle)),
            description: item.description || "",
            image: getImageDetails(item.image),
            date: item._meta.firstPublicationDate,
            badge: {
              text: "Newsletter",
              classes: "bg-peach-500 text-black",
            },
          }

        default:
          return null
      }
    })

  return withoutFalsyValues(previews)
}
